export default "__VITE_ASSET__R55nQQJs__"